export enum FileType {
  XLS = 'xls',
  PDF = 'pdf',
  CSV = 'csv',
}
